import React from "react";
// nodejs library that concatenates classes

// reactstrap components
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
} from "reactstrap";

// core components

// index page sections


import {getStats} from "../../components/helpers/StatsHelpers";
import {SeoHelper} from "../../components/helpers/SeoHelper";

class Disclaimer extends React.Component {
  state = {
    songBookCount: null
  };

  constructor(props) {
    super(props);
    getStats.call(this);
  }

  render() {
    return (
      <>
        <SeoHelper
            uri="/disclaimer"
            title = "Disclaimer | The Worship Bible"
            description={"Our website disclaimer."}
        />

        {/*<main ref="main">*/}
          <div className="position-relative">
            {/* shape Hero */}
            <section className="section section-lg section-shaped pb-250">
              <div className="shape shape-style-1 shape-default">
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
                <span/>
              </div>
              <Container className="py-lg-md d-flex">
                <div className="col px-0">
                  <Row>
                    <Col lg="8">
                      <h1 className="display-3 text-white">
                        Building your song-flows{" "}
                        <span>website disclaimer</span>
                      </h1>
                      {/*<p className="lead text-white">*/}
                      {/*  The design system comes with four pre-built pages to*/}
                      {/*  help you get started faster. You can change the text and*/}
                      {/*  images and you're good to go.*/}
                      {/*</p>*/}
                    </Col>
                  </Row>
                </div>
              </Container>
              {/* SVG separator */}
              <div className="separator separator-bottom separator-skew">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    preserveAspectRatio="none"
                    version="1.1"
                    viewBox="0 0 2560 100"
                    x="0"
                    y="0"
                >
                  <polygon
                      className="fill-white"
                      points="2560 0 2560 100 0 100"
                  />
                </svg>
              </div>
            </section>
            {/* 1st Hero Variation */}
          </div>
          <section className="section section-lg pt-lg-0 mt--200">
            <Container>
              <Row className="justify-content-center">
                <Col lg="12">
                  <Row className="row-grid">
                    <Col lg="12">
                      <Card className="card-lift--hover shadow border-0">
                        <CardBody className="py-5">
                          {/*<div className="icon icon-shape icon-shape-primary rounded-circle mb-4">*/}
                          {/*  <i className="ni ni-check-bold" />*/}
                          {/*</div>*/}
                          {/*<div dangerouslySetInnerHTML={this.privacyPolicy} />*/}
                          <Row className="justify-content-center">
                            <p className="description mt-3">
                              <img src={require("../../assets/images/termly-logo.png")} alt="Termly"/>
                            </p>
                          </Row>
                          <div className="WordSection1">
                            <h2 style={{fontSize: '1rem'}} className="text-primary text-uppercase pt-3 pb-3">
                              Website Disclaimer
                            </h2>

                            <p className="MsoNormal"><b>Last updated&nbsp;October 03, 2024</b></p>

                            <p className="MsoNormal">
                              The information provided by The Worship Bible ("we," "us," or "our") on <a
                                href="https://theworshipbible.church">theworshipbible.church</a> (the "Site")
                              for general informational purposes only. All information on the Site provided in good
                              faith,
                              however we make no representation or warranty of any kind, express or implied, regarding
                              the accuracy, adequacy, validity, reliability, availability, or
                              completeness of any information on the Site or our mobile application. UNDER NO
                              CIRCUMSTANCE SHALL WE HAVE ANY LIABILITY TO YOU FOR ANY LOSS OR DAMAGE OF
                              ANY KIND INCURRED AS A RESULT OF THE USE OF THE SITE OR OUR MOBILE APPLICATION OR RELIANCE
                              ON ANY INFORMATION PROVIDED ON THE SITE AND OUR MOBILE APPLICATION.
                              YOUR USE OF THE SITE AND OUR MOBILE APPLICATION AND YOUR RELIANCE ON ANY INFORMATION ON
                              THE SITE SOLELY AT YOUR OWN RISK.
                            </p>
                          </div>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </section>
        {/*</main>*/}
        
      </>
    );
  }
}

export default Disclaimer;
